import React, { useEffect, useState } from 'react'
import { decode } from 'html-entities'
import { eventEmitter } from '../../../../common/baseData'
import Icon from '../../../../Componentsv2/Icon/Icon'
import Lang from '../../../../Componentsv2/Lang/Lang'

function ViewedProduct (props) {
  const productInBasket = () => {
    const basketItemsMap = JSON.parse(localStorage.getItem('basketItemsMap')) || {}
    return basketItemsMap.hasOwnProperty(props.ID)
  }
  const [inBasket, setInBasket] = useState(productInBasket())
  const discount = Number(props.BASE_PRICE) > 0 && Number(props.BASE_PRICE) > Number(props.PRICE)
    ? Math.round(Number(props.BASE_PRICE) - Number(props.PRICE))
    : 0
  const discountFormated = discount > 0
    ? `-${String(discount).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')} ₴`
    : ''

  function onClick(event) {
    event.preventDefault()
    props.onClick(Number(props.ID), props.URL)
  }

  function addToBasket(event) {
    event.preventDefault()
    event.stopPropagation()

    if (inBasket) {
      eventEmitter.emit('openSmallCart')
      return
    }

    eventEmitter.emit('addToCart', { productId: Number(props.ID) })
  }

  useEffect(() => {
    const updateState = () => {
      setInBasket(productInBasket())
    }

    document.body.addEventListener('basketUpdated', updateState)

    return () => {
      document.body.removeEventListener('basketUpdated', updateState)
    }
  }, [props.ID])

  return (
    <li className={props.rootClassName}>

      <a
        className="favorite-link absolute top-2 right-[47px] z-1 block border-0 opacity-50 hover:opacity-100 desktop:right-16"
        href="#" onClick={(event) => event.preventDefault()}>
        <i className="icon-favorite"
           data-container="favorite"
           data-id={props.ID}
           data-link="/personal/wishlist/"
           data-use="add">
        </i>
      </a>
      <a
        className="comparing-link absolute top-[9px] right-[14px] z-1 block border-0 opacity-50 hover:opacity-100 desktop:right-[20px]"
        href="#" onClick={(event) => event.preventDefault()}>
        <i className="icon-comparing"
           data-container="compare"
           data-id={props.ID}
           data-link="/personal/compare/"
           data-use="add">
        </i>
      </a>

      {
        discount > 0 && (
          <span
            className="absolute top-2 left-[14px] z-1 bg-red-percent rounded-[14px] px-2 text-white text-[12px] leading-[20px] inline-block font-normal desktop:leading-[24px] desktop:top-2 desktop:left-[20px]">
            {discountFormated}
          </span>
        )
      }
      <div className="flex items-center justify-center relative">
        <a href={props.URL} onClick={onClick}
           className="flex items-center justify-center w-full desktop:w-[235px] desktop:h-[235px]">
          <img src={props.IMAGE_150_SRC}
               loading="lazy"
               alt={props.NAME}
               className="object-fill w-full h-auto"
               height="230px"
               width="230px"/>
        </a>
        {
          props.SPECIAL_DEAL && props.SPECIAL_DEAL.PICTURE && (
            <img src={props.SPECIAL_DEAL.PICTURE.src}
                 loading="lazy"
                 decoding="async"
                 fetchpriority="low"
                 className="object-cover absolute bottom-0 left-0 h-10 w-10 desktop:w-14 desktop:h-14"/>
          )
        }
      </div>
      <div className="mt-4 flex flex-col">
        <span
          className="truncate w-full overflow-hidden text-[11px] leading-[14px] h-[14px] text-grey-80">{decode(props.ARTICLE)}</span>
        <a className="text-[14px] font-normal leading-[18px] text-grey-90 line-clamp-3 h-[54px]" href={props.URL}
           onClick={onClick}>{decode(props.NAME)}</a>
      </div>
      <div className="mt-4 flex items-center h-6">
        <ul className="flex gap-1 justify-end min-h-[18px]">
          {
            Array.isArray(props.COLOR_OFFERS) && props.COLOR_OFFERS.map((offer, index) => {
              const colorClassName = String(offer.CLASS_NAME || '').replace(/\s+/g, '')

              return index < 5 ? (
                <li key={`offer-${props.ID}-${index}`}
                    className={`rounded-full w-[18px] h-[18px] ${colorClassName}`}>
                  <a href={offer.URL}
                     onClick={(event) => {
                       event.preventDefault()
                       props.onClick(Number(offer.ID || props.ID), offer.URL)
                     }}
                     className="w-full h-full inline-block"/>
                </li>
              ) : null
            })
          }
          {
            Array.isArray(props.COLOR_OFFERS) && props.COLOR_OFFERS.length > 5 && (
              <span className="text-[12px] leading-[18px]">
                {`+${props.COLOR_OFFERS.length - 5}`}
              </span>
            )
          }
        </ul>
      </div>
      <div className="mt-4 flex justify-between items-end flex-wrap gap-1">
        <div className="flex flex-col">
          {props.PRICE > 0 && props.OLD_PRICE_FORMATED &&
          props.OLD_PRICE_FORMATED.trim() !== '' &&
          props.OLD_PRICE !== 0 &&
          props.OLD_PRICE_FORMATED !== props.PRICE_FORMATED ? (
            <span
              className="text-[12px] leading-[15px] h-[15px] line-through text-grey-50 decoration-red-line-through desktop:text-[14px] desktop:leading-[17px] desktop:h-[17px]">
                  {props.OLD_PRICE_FORMATED}
                </span>
          ) : null}
          {
            props.PRICE > 0 && (
              <span
                className="text-[16px] leading-[20px] h-5 font-semibold text-grey-90 desktop:text-[20px] desktop:leading-[24px] desktop:h-6">
                {props.PRICE_FORMATED}
              </span>
            )
          }
          {
            !(props.PRICE > 0) &&
            (props.PROPERTY_NALICHIE_NAME === 'Ожидается' || props.PROPERTY_NALICHIE_NAME === 'Нет в наличии') && (
              <span className="available-status text-[14px] leading-[20px] font-normal text-grey-60 desktop:text-[16px]">
                {Lang.getMessage(props.PROPERTY_NALICHIE_NAME === 'Ожидается' ? 'productExpected' : 'productNotAvailable')}
              </span>
            )
          }
        </div>
        {
          props.PRICE > 0 && props.PROPERTY_NALICHIE_NAME === 'В наличии' && (
            <a href="#"
               className="flex items-center justify-center rounded-[14px] p-0 border-0 w-11 h-[37px] desktop:w-14 desktop:h-11"
               style={{background: props.BUTTON_COLOR_DATA && props.BUTTON_COLOR_DATA.length ? props.BUTTON_COLOR_DATA : '#6364ff'}}
               onClick={addToBasket}>
              <i data-show="basket" className="flex">
                {
                  inBasket ?
                    <Icon name={'in-cart-icon'}
                          className="h-[22px] w-[29px]"/> :
                    <Icon name={'add-to-cart-icon'}
                          className="h-[33px] w-[33px]"/>
                }
              </i>
            </a>
          )
        }
        {
          props.PROPERTY_NALICHIE_NAME === 'Ожидается' && (
            <a href="#"
               data-container="buy"
               data-product-id={props.ID}
               data-use="pre-order"
               className={`btn btn-block btn-border not-available-btn ${Number(props.PRICE) > 0 ? 'ml-auto' : ''} !py-[2px] !px-[8px] !w-11 !h-[37px] desktop:!w-14 desktop:!h-11 desktop:!py-[7px] desktop:!px-[14px]`}
               onClick={(event) => {
                 event.preventDefault()
                 eventEmitter.emit('preOrder', {
                   productId: props.ID,
                   productMerchant: props.PROPERTY_CH_MERCHANT_NAME
                 })
               }}>
              <Icon name={'preorder-icon'} className="h-[25px] w-[25px]"/>
            </a>
          )
        }
        {
          props.PROPERTY_NALICHIE_NAME === 'Нет в наличии' && (
            <a href="#"
               data-container="buy"
               data-product-id={props.ID}
               data-use="report"
               className={`btn btn-block btn-border not-available-btn !pt-[4px] !pb-[2px] !px-[8px] !w-11 !h-[37px] desktop:!w-14 desktop:!h-11 desktop:!pt-[10px] desktop:!pb-[7px] desktop:!px-[14px]`}
               onClick={(event) => {
                 event.preventDefault()
                 eventEmitter.emit('reportAvailability', {
                   productId: props.ID,
                   productMerchant: props.PROPERTY_CH_MERCHANT_NAME
                 })
               }}>
              <Icon name={'report-availability-icon'} className="h-[22px] w-[25px]"/>
            </a>
          )
        }
      </div>
    </li>
  )
}

export default ViewedProduct